import { render, staticRenderFns } from "./BarOrigineConsultationsMdtChart.vue?vue&type=template&id=5f1e4472&"
import script from "./BarOrigineConsultationsMdtChart.vue?vue&type=script&lang=ts&"
export * from "./BarOrigineConsultationsMdtChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports